/* eslint-disable max-len */
import * as yup from 'yup';

import { WORKING_DAYS_ENUM } from './types';

export const initialFlowState = {
  isLoading: true,
  isSuccess: '',
  isButtonLoading: false,
  isDeleteModalOpen: false,
}

export const initialFormState = {
}

export const timeRegex = /^([0-1]\d|2[0-3]):([0-5]\d)$/; // 24h format HH:mm

const workingDaySchema = yup.object().shape({
  enabled: yup.boolean().required(),
  from: yup
    .string()
    .matches(timeRegex, "Invalid time format (HH:mm)")
    .required("From time is required"),
  to: yup
    .string()
    .matches(timeRegex, "Invalid time format (HH:mm)")
    .required("To time is required"),
});

export const createConfigSchema = yup.object().shape({
  workingHours: yup.object().shape({
    [WORKING_DAYS_ENUM.monday]: workingDaySchema,
    [WORKING_DAYS_ENUM.tuesday]: workingDaySchema,
    [WORKING_DAYS_ENUM.wednesday]: workingDaySchema,
    [WORKING_DAYS_ENUM.thursday]: workingDaySchema,
    [WORKING_DAYS_ENUM.friday]: workingDaySchema,
    [WORKING_DAYS_ENUM.saturday]: workingDaySchema,
    [WORKING_DAYS_ENUM.sunday]: workingDaySchema,
  }),
  contactInfo: yup.object().shape({
    email: yup.string().email("Invalid email").required("Email is required"),
    phone1: yup.string().optional(),
    phone2: yup.string().optional(),
  }),
});

export const days = [
  { key: WORKING_DAYS_ENUM.monday, label: "Monday" },
  { key: WORKING_DAYS_ENUM.tuesday, label: "Tuesday" },
  { key: WORKING_DAYS_ENUM.wednesday, label: "Wednesday" },
  { key: WORKING_DAYS_ENUM.thursday, label: "Thursday" },
  { key: WORKING_DAYS_ENUM.friday, label: "Friday" },
  { key: WORKING_DAYS_ENUM.saturday, label: "Saturday" },
  { key: WORKING_DAYS_ENUM.sunday, label: "Sunday" },
];

export const hours = ["09:00", "10:00", "11:00", "18:00", "19:00", "20:00"];

export const defaultValues = {
  workingHours: {
    [WORKING_DAYS_ENUM.monday]: { enabled: true, from: "09:00", to: "18:00" },
    [WORKING_DAYS_ENUM.tuesday]: { enabled: true, from: "09:00", to: "18:00" },
    [WORKING_DAYS_ENUM.wednesday]: { enabled: true, from: "09:00", to: "18:00" },
    [WORKING_DAYS_ENUM.thursday]: { enabled: true, from: "09:00", to: "18:00" },
    [WORKING_DAYS_ENUM.friday]: { enabled: true, from: "09:00", to: "18:00" },
    [WORKING_DAYS_ENUM.saturday]: { enabled: true, from: "09:00", to: "18:00" },
    [WORKING_DAYS_ENUM.sunday]: { enabled: true, from: "09:00", to: "18:00" },
  },
  contactInfo: {
    email: "",
    phone1: "",
    phone2: "",
  }
}
